import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  createAudienceAuthentication: {
    method: 'POST',
    url: `${configs.baseUrl}/api/audience-authentication/`,
  },
  getAudienceAuthentication: {
    method: 'POST',
    url: `${configs.baseUrl}/api/audience-authentication/list/`,
  },
  deleteAudienceAuthentication: {
    method: 'POST',
    url: `${configs.baseUrl}/api/audience-authentication/delete/`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const createAudienceAuthentication = async (params) => {
  const res = await resource.createAudienceAuthentication(params)
  return res.body
}

const getAudienceAuthentication = async (params) => {
  const res = await resource.getAudienceAuthentication(params)
  return res.body
}

const deleteAudienceAuthentication = async (params) => {
  const res = await resource.deleteAudienceAuthentication(params)
  return res.body
}

export default {
  initResource,
  createAudienceAuthentication,
  getAudienceAuthentication,
  deleteAudienceAuthentication,
}
